import { Routes } from '@angular/router';
import { PaymentGuard } from '../../guards/payment.guard';
import {
  blueLogo,
  blueSmallLogo,
} from '../../services/helper.service';
import { LayoutComponent } from './layout/layout.component';
import { RedirectPageComponent } from './redirect-page/redirect-page.component';

export const Home_Routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        data: {
          joinNow: true,
          bg: 'transparent',
          scrollBg: '#fff',
          iconColor: '#fff',
          scrollIconColor: '#707A9D',
          btn: '#006de0',
          btnScroll: '#006de0',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
          showIcon: true,
        },
        loadChildren: () =>
          import('./landing-page/landing-page.routes').then((m) => m.Landing_Page_Routes),
      },
      {
        path: 'mega-sessions',
        data: {
          bg: '#f7f7f7',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./mega-session-listing/mega-session-listing.routes').then((m) => m.MegaSessionListingRoutes),
      },
      {
        path: 'about-us',
        data: {

          bg: '#fff',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./about-us/about.routes').then((m) => m.About_Routes),
      },
      {
        path: 'fees-and-payout-policy',
        data: {

          bg: 'transparent',
          scrollBg: '#fff',
          iconColor: '#fff',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./commission-policy/commission.routes').then(
            (m) => m.Commision_Routes,
          ),
      },
      {
        path: 'privacy-policy',
        data: {

          bg: 'transparent',
          scrollBg: '#fff',
          iconColor: '#fff',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./privacy-policy/privacy.routes').then(
            (m) => m.Privacy_Routes,
          ),
      },
      {
        path: 'refunds-&-dispute-policy',
        data: {

          bg: 'transparent',
          scrollBg: '#fff',
          iconColor: '#fff',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./return-policy/return.routes').then((m) => m.Return_Routes),
      },
      {
        path: 'contact-us',
        data: {

          bg: 'transparent',
          scrollBg: '#fff',
          iconColor: '#fff',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./contact-us/contact-us.routes').then((m) => m.Contact_Us_Routes),
      },
      {
        path: 'faqs',
        data: {

          bg: 'transparent',
          scrollBg: '#fff',
          iconColor: '#fff',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./faqs/faqs.routes').then((m) => m.FAQs_Routes),
      },
      {
        path: 'terms-and-condition',
        data: {

          bg: 'transparent',
          scrollBg: '#fff',
          iconColor: '#fff',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./terms-conditions/terms.routes').then((m) => m.Terms_Routes),
      },
      {
        path: 'become-a-creator',
        data: {

          joinNow: true,
          bg: 'transparent',
          scrollBg: '#fff',
          iconColor: '#fff',
          scrollIconColor: '#707A9D',
          btn: '#006de0',
          btnScroll: '#006de0',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./landing-page/landing-page.routes').then((m) => m.Landing_Page_Routes),
      },
      {
        path: 'becomeacreator',
        redirectTo: '/',
        pathMatch: 'full' // Ensures that the entire path must match
      },
      {
        path: 'creators',
        data: { scroll: 'center' },
        loadChildren: () =>
          import('./collection/collection.routes').then((m) => m.routes),
      },
      {
        path: 'payment',
        canActivate: [PaymentGuard],
        data: {

          bg: '#fff',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./payment/payment.routes').then((m) => m.Payment_Routes),
      },
      {
        path: ':uniqueName/payment-success',
        data: {

          bg: '#fff',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./payment-success/payment-success.routes').then(
            (m) => m.PaymentSuccess_Routes,
          ),
      },
      {
        path: 'checkout',
        data: {
          bg: '#f7f7f7',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./checkout/checkout.routes').then((m) => m.checkoutRoutes),
      },
      {
        path: 'mentoronline/:uniqueName',
        component: RedirectPageComponent,
      },
      {
        path: 'Booking/:uniqueName',
        component: RedirectPageComponent,
      },
      {
        path: 'booking/:uniqueName',
        component: RedirectPageComponent,
      },
      {
        path: ':uniqueName',
        data: {
          bg: '#f7f7f7',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./profile-page/profile.routes').then((m) => m.Profile_Routes),
      },
      {
        path: 'recordings/:creatorId',
        data: {
          bg: '#f7f7f7',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./recorded-mega-session-listing/recorded-mega-session-listing.routes').then((m) => m.RecordedMegaSessionListingRoutes),
      },
      {
        path: 'mega-sessions/recordings',
        data: {
          bg: '#f7f7f7',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./recorded-mega-session-listing/recorded-mega-session-listing.routes').then((m) => m.RecordedMegaSessionListingRoutes),
      },
      {
        path: 'mentor-review/:creatorId',
        data: {
          bg: '#f7f7f7',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./mentor-reviews/mega-session-listing.routes').then((m) => m.MegaSessionListingRoutes),
      },
      {
        path: 'mega-sessions/:creatorId',
        data: {
          bg: '#f7f7f7',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./user-mega-session-listing/user-mega-session-listing.routes').then((m) => m.UserMegaSessionListingRoutes),
      },
      {
        path: ':uniqueName/mega-session/:sessionId',
        data: {
          bg: '#f7f7f7',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./mega-session-details/mega-session-details.routes').then((m) => m.MegaSessionRoutes),
      },
      {
        path: ':uniqueName/recording/:recordingId',
        data: {
          bg: '#f7f7f7',
          scrollBg: '#fff',
          iconColor: '#707A9D',
          scrollIconColor: '#707A9D',
          btn: '#2255da',
          btnScroll: '#2255da',
          color: '#fff',
          scrollColor: '#fff',
          logo: blueLogo,
          scrollLogo: blueLogo,
          smallLogo: blueSmallLogo,
          smallScrollLogo: blueSmallLogo,
        },
        loadChildren: () =>
          import('./mega-session-details/mega-session-details.routes').then((m) => m.MegaSessionRoutes),
      },
    ],
  },
];
